import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { ProductionService } from '@app/shared/services/production.service';
import { forkJoin } from 'rxjs';

import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-print-prod',
  templateUrl: './print-prod.component.html',
  styleUrls: ['./print-prod.component.css']
})
export class PrintProdComponent implements OnInit  {


    printingId: string | null = null; // To hold the printing ID
  
    
    serialNo: number = 1;      // Variable to track serial number
  
    isViewMode: boolean = false; // New property to determine view mode
  
  
  
    printingData: any = {};  // Declare printingData as an object to store the data from the server
    // Flag to track if the saving process is ongoing
    processing: boolean = false;
  
    rolls = [];  // This will store roll information for the table.
  
   
  
    printingForm!: FormGroup;
    
    
      
    
  
    // 
    batchDialogVisible = false;
  selectedBatchRow: FormGroup | null = null;
  
  // for incrementing output roll number automatically inside the popup
  lastUsedRollNo: string = '';
  
  selectedMaterialRow: FormGroup | null = null;
  
  intervalId: any; 



  

  inkingDialogVisible = false;

// Holds the current entry
currentInk = {
  inkName: '',
  inkColor: '',
  inkType: '',
  issue:'',
  return:'',

  solidPercent: '',
  liquidCons:'',
  solidCons:'',

};
// Stores all saved entries
inkingData: any[] = [];




// for tabbing
basicInfoVisible: boolean = false; // ✅ closed by default
materialDetailsVisible: boolean = true;
inventoryDetailsVisible: boolean = false;
outputDetailsVisible: boolean = false;

setTab(tab: 'material' | 'inventory' | 'output') {
  this.materialDetailsVisible = tab === 'material';
  this.inventoryDetailsVisible = tab === 'inventory';
  this.outputDetailsVisible = tab === 'output';
}

  
  
    constructor(private fb: FormBuilder,   private route: ActivatedRoute,private cdr: ChangeDetectorRef,private productionService: ProductionService,private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,private Router:Router,
  
  
    ) {}
  
    ngOnInit(): void {
      this.initializeForm();
     
      this.printingId = this.route.snapshot.paramMap.get('id'); // Get the ID from route
  
      this.initializeForm();

      // forkJoin({
      //       repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
      //       unsavedOrders: this.orderDataService.getAllUnsavedOrders()
      //     }).subscribe(response => {
      //       // Ensure the response objects are arrays, otherwise set them as empty arrays
      //       const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];
      //       const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];
      
      //       // Combine both orders into a single array (could also add custom properties to differentiate)
      //       this.tickets = [...repeatOrders, ...unsavedOrders];
      //        // Sort tickets in ascending order based on ticketNo
      //     this.tickets.sort((a, b) => {
      //       const ticketNoA = a.ticketNo ? a.ticketNo : '';
      //       const ticketNoB = b.ticketNo ? b.ticketNo : '';
      //       return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
      //     });
      
      //       this.cdr.detectChanges(); // This forces the UI to update after data is populated
      
      //       console.log("ticket",this.tickets);
      //     });
      forkJoin({
     
      unsavedOrders: this.orderDataService.getAllUnsavedOrders(),
        repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    }).subscribe(response => {
      // Ensure the response objects are arrays, otherwise set them as empty arrays
    
      const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];
        const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];

      // Combine both orders into a single array (could also add custom properties to differentiate)
     
       this.tickets = [...unsavedOrders, ...repeatOrders];
       // Sort tickets in ascending order based on ticketNo
    // this.tickets.sort((a, b) => {
    //   const ticketNoA = a.ticketNo ? a.ticketNo : '';
    //   const ticketNoB = b.ticketNo ? b.ticketNo : '';
    //   return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    // });
    this.tickets.sort((a, b) => {
  const ticketNoA = a.ticketNo ? a.ticketNo : '';
  const ticketNoB = b.ticketNo ? b.ticketNo : '';
  return ticketNoA.localeCompare(ticketNoB);
}).reverse();


      this.cdr.detectChanges(); // This forces the UI to update after data is populated

      console.log("ticket",this.tickets);
    });
      
    
  
      
  // setInterval(() => {
  //   if (!this.batchDialogVisible) {
  //     this.materialDetails.controls.forEach((row: FormGroup) => {
  //       this.openBatchDialog(row, false); // Run calculations silently
  //     });
  //   }
  // }, 5000);

  
    }
  
  
    
    private currentRollNumber: number = 0;
  
  // Called during ngOnInit()
  // setInitialRollNo(): void {
  //   this.laminationService.getHighestRollNo().subscribe((highestRollNo: any) => {
  //     if (highestRollNo && highestRollNo.startsWith('247P')) {
  //       const lastCount = parseInt(highestRollNo.slice(4), 10);
  //       this.currentRollNumber = lastCount;
  //       this.lastUsedRollNo = `247P${this.formatNumberRoll(this.currentRollNumber)}`;
  //     } else {
  //       this.currentRollNumber = 0;
  //       this.lastUsedRollNo = '247P00000';
  //     }
  //   });
  // }
  
  // // Use this to get the next roll number without hitting the server again
  // getNextRollNo(): Promise<string> {
  //   return new Promise((resolve) => {
  //     this.currentRollNumber++;
  //     const next = `247P${this.formatNumberRoll(this.currentRollNumber)}`;
  //     resolve(next);
  //   });
  // }
    
  
  
  
  
  
  
   
   
  
  
  
    // Get the next highestLamination
  // getLaminationNo(): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     this.laminationService.getHighestLaminationProNo().subscribe((highestLamination: any) => {
  //       const now = new Date();
  //       const year = now.getFullYear().toString().slice(-2);  // Get last 2 digits of the year
  //       const month = (now.getMonth() + 1).toString().padStart(2, '0');  // Get month in 2 digits
  
  //       // Check if the highest highestLamination number matches the current year and month
  //       if (highestLamination && highestLamination.startsWith(`PR${year}${month}`)) {
  //         const lastCount = parseInt(highestLamination.slice(-5), 10); // Take the last 5 digits for the count
  //         const nextCount = (lastCount >= 99999) ? 1 : lastCount + 1;  // Increment or reset to 1 if limit reached
  //         const incrementCount = this.formatNumber(nextCount);  // Format to 5 digits
  //         resolve(`PR${year}${month}${incrementCount}`);  // Return formatted Lamination No.
  //       } else {
  //         resolve(`PR${year}${month}00001`);  // Start from PRyyyyMM00001 if no record found
  //       }
  //     });
  //   });
  // }
  
  // // Format number with leading zeros for the sequence (e.g., 00001, 00002, ..., 99999)
  // private formatNumber(number: number): string {
  //   return number.toString().padStart(5, '0');  // Ensure 5 digits (e.g., 00001, 00002)
  // }
  
  // // Set the laminationForm field in the form
  // setLaminationNo(): void {
  //   this.getLaminationNo().then(prNo => {
  //     this.laminationForm.patchValue({
  //       prNo: prNo   // Set the generated laminationForm in the form
  //     });
  //   }).catch(error => {
  //     console.error('Error generating lamination Production :', error);
  //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate Lamination Production ' });
  //   });
  // }
  
  
  
  // getRollNo(): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     this.laminationService.getHighestRollNo().subscribe((highestRollNo: any) => {
  //       if (highestRollNo && highestRollNo.startsWith('247P')) {
  //         const lastCount = parseInt(highestRollNo.slice(-5), 10);  // Extract last 5 digits
  //         const nextCount = (lastCount >= 99999) ? 0 : lastCount + 1;
  //         const formattedCount = this.formatNumberRoll(nextCount);
  //         resolve(`247P${formattedCount}`);
  //       } else {
  //         resolve('247P00001');
  //       }
  //     }, error => {
  //       console.error('Error fetching highest roll no:', error);
  //       reject(error);
  //     });
  //   });
  // }
  // private formatNumberRoll(number: number): string {
  //   return number.toString().padStart(5, '0');
  // }
  
  // setRollNo(): void {
  //   this.getRollNo().then(rollNo => {
  //     this.laminationForm.patchValue({ rollNo: rollNo });
  //   }).catch(error => {
  //     console.error('Failed to set Roll No:', error);
  //     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to generate Roll No' });
  //   });
  // }
  
  
  
  
  
    private initializeForm(): void {
      this.printingForm = this.fb.group({
  


      orderKgs: [null, Validators.required],
      poNo: [null, Validators.required],
      clientName: [null, Validators.required],
      ticketNo: [null, Validators.required],

      refNo: [null, Validators.required],
      jobName: [null, Validators.required],
      poNumber: [null, Validators.required],

      shift:['', Validators.required],
      machine: ['', Validators.required],
      operator :['', Validators.required],
      timeFrom : ['00:00', Validators.required],
      timeTo :['00:00', Validators.required],
      operatingTime :['', Validators.required],
      mcSpeed :[null, Validators.required],
      inkGsm :[null, Validators.required], 



      totalWastage: [0],
      totalKgs: [0],
      totalJoint: [0],
      totalReturn: [0],
      totalConsumption: [0],
          totalMtrs: [0],
      netConsumption: [0],

      totalOutputKgs: [0],
      totalOutputMeters: [0],
      totalOutputFlags: [0],
      totalOutputWastage: [0],
      netTotalConsumption: [0],


    //  ink
      totalInkLiquidCons: [0],
      totalInkIssue: [0],
      totalInkReturn: [0],
      totalInkSolidCons: [0],
      // solvent
      totalSolventIssue: [0],
totalSolventReturn: [0],
totalSolventConsumption: [0],
// breakdown
totalBreakdownTime: [0],




        // for total of output roll
         totalWastageOutputRoll: [0],
        totalKgsOutputRoll : [0],
         totalJointOutputRoll : [0],
         totalMtrsOutputRoll : [0],

             // Calculate net consumption
     netConsumptionOutputRoll : [0],
        // 


      
  
    //  table
    materialDetails: this.fb.array([this.createMaterialRow()]),
// another array
    inventoryDetails: this.fb.array([this.createInventoryRow()]), // <-- NEW ARRAY
    outputDetails: this.fb.array([this.createOutputRow()]),
    



    inking: [[]], // stores the array of inking records
    breakdown: [[]],
    solvent: [[]],
  
  
    // for including batch data in material array
    // batches: this.fb.array([]) // <--- Add this for storing batch list
      });

       // Listen for changes on timeFrom and timeTo fields
     this.printingForm.get('timeFrom')?.valueChanges.subscribe(() => {
      this.calculateTimeDifference();
    });

    this.printingForm.get('timeTo')?.valueChanges.subscribe(() => {
      this.calculateTimeDifference();
    });



    // for calculation itemConsumption in array
    this.printingForm.get('materialDetails')?.valueChanges.subscribe(() => {
      this.calculateItemConsumptionForMaterial();
    });
    this.printingForm.get('inventoryDetails')?.valueChanges.subscribe(() => {
      this.calculateItemConsumptionForInventory();
    });
    
    
    }
  
    // 
  
    get batches(): FormArray {
      return this.printingForm.get('batches') as FormArray;
    }
  
    createBatchRow(data: any): FormGroup {
      return this.fb.group({
        batchNo: [data.batchNo || ''],
       
        remark: [data.remark || ''],
  
     
  
        // dialogGross: [data.dialogGross || ''],
        // dialogCore: [data.dialogCore || ''],
        // dialogNet: [data.dialogNet || ''],
        dialogMeter: [data.dialogMeter || ''],
        dialogColor: [data.dialogColor || ''],
        dialogText: [data.dialogText || ''],
       
  
        //for fetching details from forms table
      dialogInputRoll: [data.dialogInputRoll || ''],
      // dialogUsed: [data.dialogUsed || ''],
      // dialogScrap: [data.dialogScrap || ''],
      // dialogInk: [data.dialogInk || ''],
  
      dialogInBlnWt: [data.dialogInBlnWt || ''],
      });
    }
  
    
  
    addBatchToList(): void {
      if (this.selectedBatchRow && this.selectedMaterialRow) {
        const batchData = this.selectedBatchRow.value;
        const batchesArray = this.selectedMaterialRow.get('batches') as FormArray;
    
        if (batchesArray) {
          if (this.editingBatchIndex !== null) {
            // ✅ Editing an existing batch — no change to roll number
            batchesArray.at(this.editingBatchIndex).patchValue(batchData);
          } else {
            // ✅ Adding new batch
            batchesArray.push(this.createBatchRow(batchData));
            // this.updateItemInkFromColorTotal();
            // this.updateItemScrapFromMeterTotal()
            this.updateAllBatchLinkedTotals();


    
            // ✅ Set 'lastUsedRollNo' to the current one
            this.lastUsedRollNo = batchData.batchNo;
            this.selectedMaterialRow.get('lastUsedRollNo')?.setValue(this.lastUsedRollNo);
    
            // ✅ Prepare next roll number (increment from current one)
           
            // this.getNextRollNo().then(nextRollNo => {
            //   this.lastUsedRollNo = nextRollNo;
            
            //   // Update form or UI as needed
            //   this.printingForm.patchValue({ rollNo: nextRollNo });
            
            //   console.log('Next Roll No prepared fir the new form submission:', nextRollNo);
            // });
          }
    
          // Update current batch roll in parent if needed
          this.selectedMaterialRow.patchValue({ batchNo: batchData.batchNo });
        }
    
        // Reset dialog state
        this.batchDialogVisible = false;
        this.selectedBatchRow = null;
        this.selectedMaterialRow = null;
        this.editingBatchIndex = null;
      }
    }
    
  
    // 

    // for patching form table with dialog
    // updateItemInkFromColorTotal(): void {
    //   const batches = this.selectedMaterialRow?.get('batches')?.value || [];
    
    //   const totalColor = batches.reduce((sum: number, batch: any) => {
    //     const val = +batch.dialogColor || 0;
    //     return sum + val;
    //   }, 0);
    
    //   // Patch to itemInk
    //   this.selectedMaterialRow?.get('itemInk')?.setValue(totalColor, { emitEvent: false });
    // }
    // updateItemScrapFromMeterTotal(): void {
    //   const batches = this.selectedMaterialRow?.get('batches')?.value || [];
    
    //   const totalMeters = batches.reduce((sum: number, batch: any) => {
    //     const val = +batch.dialogMeter || 0;
    //     return sum + val;
    //   }, 0);
    
    //   // Patch to itemScrap
    //   this.selectedMaterialRow?.get('itemScrap')?.setValue(totalMeters, { emitEvent: false });
    // }
    updateItemInkFromColorTotal(): void {
      const batches = this.selectedMaterialRow?.get('batches')?.value || [];
      const totalColor = batches.reduce((sum: number, batch: any) => sum + (+batch.dialogColor || 0), 0);
      this.selectedMaterialRow?.get('itemInk')?.setValue(totalColor, { emitEvent: false });
    }
    
    updateItemScrapFromMeterTotal(): void {
      const batches = this.selectedMaterialRow?.get('batches')?.value || [];
      const totalMeter = batches.reduce((sum: number, batch: any) => sum + (+batch.dialogMeter || 0), 0);
      this.selectedMaterialRow?.get('itemScrap')?.setValue(totalMeter, { emitEvent: false });
    }
    
    updateItemUsedFromTextTotal(): void {
      const batches = this.selectedMaterialRow?.get('batches')?.value || [];
      const totalText = batches.reduce((sum: number, batch: any) => sum + (+batch.dialogText || 0), 0);
      this.selectedMaterialRow?.get('itemUsed')?.setValue(totalText, { emitEvent: false });
    }
    
    updateItemBalancedFromRemarksTotal(): void {
      const batches = this.selectedMaterialRow?.get('batches')?.value || [];
      const totalRemark = batches.reduce((sum: number, batch: any) => sum + (+batch.remark || 0), 0);
      this.selectedMaterialRow?.get('itemBalanced')?.setValue(totalRemark, { emitEvent: false });
    }

    updateAllBatchLinkedTotals(): void {
      this.updateItemInkFromColorTotal();
      this.updateItemScrapFromMeterTotal();
      this.updateItemUsedFromTextTotal();
      this.updateItemBalancedFromRemarksTotal();
    }
    
    
    // 
    
  
    get materialDetails(): FormArray {
      return this.printingForm.get('materialDetails') as FormArray;
    }
  
    
    createMaterialRow(): FormGroup {
      return this.fb.group({
        woNo: [''],
        itemWidth: [''],
        itemThickness: ['', Validators.required],
        itemGross: ['', Validators.required],
        itemScrap: [''],
        itemUsed: [''],
        itemBalanced: [''],
        itemInk: [''],
        batchNo: [''],
        // dialogGross: [''],
        // dialogCore: [''],
        // dialogNet: [''],
        dialogMeter: [''],
        dialogColor: [''],
        dialogText: [''],
      
        remark: [''],
        dialogInputRoll: [''],
        // dialogUsed: [''],
        // dialogScrap: [''],
        // dialogInk: [''],
  
        dialogInBlnWt: [''],

        itemWastage: [''],

        itemConsumption: [''],
        itemMtrs: [''],
  
        
        // NEW: attach batch list to each row
        batches: this.fb.array([])
      });
    }
    
  
    addRow(): void {
      this.materialDetails.push(this.createMaterialRow());
    }
  
  
    removeRow(index: number): void {
      this.materialDetails.removeAt(index);
    }
  

    calculateTimeDifference(): void {
      const timeFrom = this.printingForm.get('timeFrom')?.value;
      const timeTo = this.printingForm.get('timeTo')?.value;
    
      // Ensure both timeFrom and timeTo are valid before calculating
      if (timeFrom && timeTo) {
        const timeFromDate = this.convertTimeToDate(timeFrom);
        const timeToDate = this.convertTimeToDate(timeTo);
    
        // Calculate the time difference in milliseconds
        const diffInMilliseconds = timeToDate.getTime() - timeFromDate.getTime();
    
        // Convert the difference into minutes
        const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60)); // Minutes
    
        // Update the operatingTime field to display the time difference in minutes format
        this.printingForm.patchValue({
          operatingTime: `${diffInMinutes} minutes`  // Displaying it as "XXX minutes"
        });
    
        // Print the difference in the console in minutes format
        console.log('Operating Time Difference:', `${diffInMinutes} minutes`);
      }
    }

    // Helper function to convert time string to Date object
  convertTimeToDate(time: string): Date {
    const [hours, minutes] = time.split(':').map(num => parseInt(num, 10));
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    return date;
  }

  // Helper function to format hours and minutes as HH:mm
  formatTime(hours: number, minutes: number): string {
    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    return `${formattedHours}:${formattedMinutes}`;
  }

    
  
    
// another array
  createInventoryRow(): FormGroup {
    return this.fb.group({
      woNo: [''],
      itemWidth: [''],
      itemThickness: ['', Validators.required],
      itemGross: ['', Validators.required],
      itemScrap: [''],
      itemUsed: [''],
      itemBalanced: [''],
      itemInk: [''],
      batchNo: [''],
      dialogMeter: [''],
      dialogColor: [''],
      dialogText: [''],
      remark: [''],
      dialogInputRoll: [''],
      dialogInBlnWt: [''],
      itemWastage: [''],
      itemConsumption: [''],
      itemMtrs: [''],
      batches: this.fb.array([]) // optional if batch functionality needed
    });
  }

  get inventoryDetails(): FormArray {
    return this.printingForm.get('inventoryDetails') as FormArray;
  }

  addInventoryRow(): void {
    this.inventoryDetails.push(this.createInventoryRow());
  }
  
  removeInventoryRow(index: number): void {
    this.inventoryDetails.removeAt(index);
  }

  getInventoryTotal(fieldName: string): number {
    return this.inventoryDetails.controls.reduce((total, control) => {
      const val = parseFloat(control.get(fieldName)?.value) || 0;
      return total + val;
    }, 0);
  }




  createOutputRow(): FormGroup {
    return this.fb.group({
      woNo: [''],
      itemWidth: [''],
      itemThickness: ['', Validators.required],
      itemGross: ['', Validators.required],
      itemScrap: [''],
      itemUsed: [''],
      itemBalanced: [''],
      itemInk: [''],
      batchNo: [''],
      dialogMeter: [''],
      dialogColor: [''],
      dialogText: [''],
      remark: [''],
      dialogInputRoll: [''],
      dialogInBlnWt: [''],
      itemWastage: [''],
      itemConsumption: [''],
      itemMtrs: [''],
      batches: this.fb.array([]) // optional if batch functionality is needed
    });
  }
  get outputDetails(): FormArray {
    return this.printingForm.get('outputDetails') as FormArray;
  }
  addOutputRow(): void {
    this.outputDetails.push(this.createOutputRow());
  }
  
  removeOutputRow(index: number): void {
    this.outputDetails.removeAt(index);
  }
  getOutputTotal(fieldName: string): number {
    return this.outputDetails.controls.reduce((total, control) => {
      const val = parseFloat(control.get(fieldName)?.value) || 0;
      return total + val;
    }, 0);
  }




  calculateItemConsumptionForMaterial(): void {
    this.materialDetails.controls.forEach((row: AbstractControl) => {
      const itemGross = parseFloat(row.get('itemGross')?.value) || 0;
      const itemThickness = parseFloat(row.get('itemThickness')?.value) || 0;
      const consumption = itemGross - itemThickness;
  
      row.get('itemConsumption')?.setValue(consumption, { emitEvent: false });
    });
  }
  
  calculateItemConsumptionForInventory(): void {
    this.inventoryDetails.controls.forEach((row: AbstractControl) => {
      const itemGross = parseFloat(row.get('itemGross')?.value) || 0;
      const itemThickness = parseFloat(row.get('itemThickness')?.value) || 0;
      const consumption = itemGross - itemThickness;
  
      row.get('itemConsumption')?.setValue(consumption, { emitEvent: false });
    });
  }
  
        
  
  
  
  
  
    // 
    // working perfectly but we need output roll number increment on each usage
  
    // 
    // incrementRollNo(current: string): string {
    //   const prefix = current.slice(0, 4); // '247P'
    //   const numberPart = parseInt(current.slice(4), 10); // e.g., 33
    //   const next = numberPart + 1;
    //   return `${prefix}${this.formatNumberRoll(next)}`; // e.g., 247P00034
    // }
  
  openBatchDialog(row: FormGroup, showPopup: boolean = true): void {
  // openBatchDialog(row: FormGroup): void {
    const generatedRollNo = this.lastUsedRollNo;
  
    // Save selected row so batches can be saved into this later
    this.selectedMaterialRow = row;


  
    // Fill default values for the batch dialog
    this.selectedBatchRow = this.fb.group({
  
      woNo: [row.get('woNo')?.value || ''],
  
  
      batchNo: [generatedRollNo],
     
      remark: [''],
  
      // dialogGross: [''],
      // dialogCore: [''],
      // dialogNet: [''],
      dialogMeter: [''],
      dialogColor: [''],
      dialogText: [''],
  
      dialogInputRoll: [row.get('itemGross')?.value || ''],
    
      // dialogUsed: [''],
      // dialogScrap: [''],
      // dialogInk: [''],
  
      dialogInBlnWt: [''],
    });
  
    // Open the dialog
    // this.batchDialogVisible = true;
    if (showPopup) {
      this.batchDialogVisible = true;
    }
  
    // Set up real-time calculations
    const grossCtrl = this.selectedBatchRow.get('dialogGross');
    const coreCtrl = this.selectedBatchRow.get('dialogCore');
    const netCtrl = this.selectedBatchRow.get('dialogNet');
  
    const inputCtrl = this.selectedBatchRow.get('dialogInputRoll');
    const usedCtrl = this.selectedBatchRow.get('dialogUsed');
    const scrapCtrl = this.selectedBatchRow.get('dialogScrap');
  
    const inBlnWtCtrl = this.selectedBatchRow.get('dialogInBlnWt');
    const inkCtrl = this.selectedBatchRow.get('dialogInk');
  
    // Net = Gross - Core
    const updateNet = () => {
      const gross = +grossCtrl?.value || 0;
      const core = +coreCtrl?.value || 0;
      netCtrl?.setValue(gross - core, { emitEvent: false });
    };
  
    // Scrap = Input - Used
    // const updateScrap = () => {
    //   const input = +inputCtrl?.value || 0;
    //   const used = +usedCtrl?.value || 0;
    //   scrapCtrl?.setValue(input - used, { emitEvent: false });
    // };
  
     // 3. dialogInBlnWt = dialogInputRoll - dialogUsed - dialogScrap
     const updateInBlnWt = () => {
      const input = +inputCtrl?.value || 0;
      const used = +usedCtrl?.value || 0;
      const scrap = +scrapCtrl?.value || 0;
      const inBln = input - used - scrap;
      inBlnWtCtrl?.setValue(inBln, { emitEvent: false });
      console.log('Calculated dialogInBlnWt:', inBln);
  
      // row.get('itemBalanced')?.setValue(inBln, { emitEvent: false });
      

      
  
  
      // 
    //   const scrapRaw = scrapCtrl?.value;
  
    // // Only perform calculation if user has entered a value
    // if (scrapRaw !== null && scrapRaw !== '' && scrapRaw !== undefined) {
    //   const input = +inputCtrl?.value || 0;
    //   const used = +usedCtrl?.value || 0;
    //   const scrap = +scrapRaw || 0;
  
    //   const inBln = input - used - scrap;
    //   inBlnWtCtrl?.setValue(inBln, { emitEvent: false });
    // }
    // 
    };
  


    
  
    // Subscribe to changes
    grossCtrl?.valueChanges.subscribe(updateNet);
    coreCtrl?.valueChanges.subscribe(updateNet);
    // inputCtrl?.valueChanges.subscribe(updateScrap);
    // usedCtrl?.valueChanges.subscribe(updateScrap);
  
    
    inputCtrl?.valueChanges.subscribe(() => {
      // updateScrap();
      // updateInBlnWt();
     
    });
  
    usedCtrl?.valueChanges.subscribe(() => {
      // updateScrap();
      // updateInBlnWt();
    
  
        // Sync itemUsed in row
    // row.get('itemUsed')?.setValue(usedCtrl.value, { emitEvent: false });
    });
  
    // scrapCtrl?.valueChanges.subscribe(() => {
    //   updateInBlnWt();
     
  
    //   row.get('itemScrap')?.setValue(scrapCtrl.value, { emitEvent: false });
    // });
  
    
    updateNet();
    // updateScrap();
    // updateInBlnWt();
    // updateInk();
  
    //  Patch total Net Wt. into dialogUsed field
  // const totalNet = this.netWeightTotal;
  // this.selectedBatchRow.get('dialogUsed')?.setValue(totalNet);
  // // Also update itemUsed in row
  // row.get('itemUsed')?.setValue(totalNet, { emitEvent: false });
  
  // console.log('inBlnWtDisplayedTotal:', this.inBlnWtDisplayedTotal);
  }



  
  
  get netWeightTotal(): number {
    const batches = this.selectedMaterialRow?.get('batches')?.value || [];
    return batches.reduce((total: number, batch: any) => {
      return total + (+batch.dialogNet || 0);
    }, 0);
  }
  
  get inBlnWtDisplayedTotal(): number {
    const batchesCount = this.selectedMaterialRow?.get('batches')?.value?.length || 0;
    const singleValue = +this.selectedBatchRow?.controls['dialogInBlnWt']?.value || 0;
    return batchesCount * singleValue;
  }
  
  
  
  onBatchDialogClose() {
    this.batchDialogVisible = false;
  
    this.selectedBatchRow = null;
    this.editingBatchIndex = null;  // Clear edit state
  }
  
  
  
  
  // 
  // 
   // for incrementing output roll number automatically inside the popup
  // generateNextRollNo(): string {
  //   const prefix = '247P';
  //   const lastNumber = parseInt(this.lastUsedRollNo.slice(4), 10);
  //   const nextNumber = lastNumber + 1;
  //   const nextRollNo = `${prefix}${this.formatNumberRoll(nextNumber)}`;
  //   this.lastUsedRollNo = nextRollNo;
  //   return nextRollNo;
  // }
  
  
  // 
  //
  
  

  openInkingDialog() {
    this.inkingDialogVisible = true;
    this.resetCurrentInk();
  }
  
  closeInkingDialog() {
    this.inkingDialogVisible = false;
  }



  // For edit tracking
editingIndex: number = -1;
  
  // Saves one record to the array
  saveInking() {
    // Prevent empty values from being saved (optional)
    if (!this.currentInk.inkName || !this.currentInk.inkColor) return;
  
    // Push current entry to the saved list
    // this.inkingData.push({ ...this.currentInk });
    // with edit also
    if (this.editingIndex === -1) {
      // Add new
      this.inkingData.push({ ...this.currentInk });
    } else {
      // Update existing
      this.inkingData[this.editingIndex] = { ...this.currentInk };
      this.editingIndex = -1;
    }
  
    // If using reactive form, update the form group
    this.printingForm.patchValue({ inking: this.inkingData });
  
    // Clear fields for next input
    this.resetCurrentInk();
  }
  
  // Clears the form fields
  resetCurrentInk() {
    this.currentInk = {
      inkName: '',
      inkColor: '',
      inkType: '',
      issue: '',
      return: '',

      solidPercent: '',
      liquidCons: '',
      solidCons: '',
    };
  }


  editInk(index: number) {
    this.currentInk = { ...this.inkingData[index] };
    this.editingIndex = index;

      // ✅ Recalculate in case issue/return/solidPercent were edited
      this.currentInk.liquidCons = this.getLiquidCons(this.currentInk).toString();
      this.currentInk.solidCons = this.getSolidCons(this.currentInk).toString();
  }
  
  deleteInk(index: number) {
    this.inkingData.splice(index, 1);
    this.printingForm.patchValue({ inking: this.inkingData });
  
    if (this.editingIndex === index) {
      this.resetCurrentInk();
      this.editingIndex = -1;
    }
  }

  // calculation
  getLiquidCons(ink: any): number {
    const issue = parseFloat(ink.issue) || 0;
    const ret = parseFloat(ink.return) || 0;
    return +(issue - ret).toFixed(2);
  }
  
  getSolidCons(ink: any): number {
    const liquidCons = this.getLiquidCons(ink);
    const solidPercent = parseFloat(ink.solidPercent) || 0;
    return +((liquidCons * solidPercent) / 100).toFixed(2);
  }
  // 
  
  // total calculation
  getInkTotal(field: 'issue' | 'return' | 'solidPercent'): number {
    return this.inkingData.reduce((total, ink) => {
      const value = parseFloat(ink[field]) || 0;
      return total + value;
    }, 0);
  }
  
  getTotalLiquidCons(): number {
    return this.inkingData.reduce((total, ink) => {
      const issue = parseFloat(ink.issue) || 0;
      const ret = parseFloat(ink.return) || 0;
      return total + (issue - ret);
    }, 0);
  }
  
  getTotalSolidCons(): number {
    return this.inkingData.reduce((total, ink) => {
      const liquidCons = (parseFloat(ink.issue) || 0) - (parseFloat(ink.return) || 0);
      const solidPercent = parseFloat(ink.solidPercent) || 0;
      return total + (liquidCons * solidPercent / 100);
    }, 0);
  }

  updateSolidCons(ink: any) {
    ink.solidCons = this.getSolidCons(ink);
    ink.liquidCons = this.getLiquidCons(ink);  // just in case
    // Also update the form patch if needed
    this.printingForm.patchValue({ inking: this.inkingData });
  }
  
  
  get totalGrossWt(): number {
    return this.materialDetails.controls.reduce((sum, row) => sum + (+row.get('itemGross')?.value || 0), 0);
  }
  
  // get totalScrapWt(): number {
  //   return this.materialDetails.controls.reduce((sum, row) => sum + (+row.get('itemScrap')?.value || 0), 0);
  // }
  
  // get totalUsedWt(): number {
  //   return this.materialDetails.controls.reduce((sum, row) => sum + (+row.get('itemUsed')?.value || 0), 0);
  // }
  
  // get totalBalancedWt(): number {
  //   return this.materialDetails.controls.reduce((sum, row) => sum + (+row.get('itemBalanced')?.value || 0), 0);
  // }
  
  // get totalInkGainWt(): number {
  //   return this.materialDetails.controls.reduce((sum, row) => sum + (+row.get('itemInk')?.value || 0), 0);
  // }
  
  
  // for total
  getTotal(fieldName: string): number {
    return this.materialDetails.controls.reduce((total, control) => {
      const val = parseFloat(control.get(fieldName)?.value) || 0;
      return total + val;
    }, 0);
  }



  getBatchTotal(fieldName: string): number {
    const batches = this.selectedMaterialRow?.get('batches')?.value || [];
    return batches.reduce((acc: number, batch: any) => {
      const value = parseFloat(batch[fieldName]);
      return acc + (isNaN(value) ? 0 : value);
    }, 0);
  }

  


  breakdownDialogVisible = false;
  fixedMinutes: string[] = ['00', '15', '30', '45', '60'];


currentBreakdown = {
  downTime: '',
  downTimeTime: '',
  downTimeRemarks: ''
};

breakdownData: any[] = [];
breakdownEditingIndex: number = -1;

openBreakdownDialog() {
  this.breakdownDialogVisible = true;
  this.resetCurrentBreakdown();
}

closeBreakdownDialog() {
  this.breakdownDialogVisible = false;
  this.breakdownEditingIndex = -1;
  this.resetCurrentBreakdown();
}

saveBreakdown() {
  if (!this.currentBreakdown.downTime || !this.currentBreakdown.downTimeTime) return;

  if (this.breakdownEditingIndex === -1) {
    this.breakdownData.push({ ...this.currentBreakdown });
  } else {
    this.breakdownData[this.breakdownEditingIndex] = { ...this.currentBreakdown };
    this.breakdownEditingIndex = -1;
  }

  this.resetCurrentBreakdown();
  this.printingForm.patchValue({ breakdown: this.breakdownData });
}

editBreakdown(index: number) {
  this.currentBreakdown = { ...this.breakdownData[index] };
  this.breakdownEditingIndex = index;
}

deleteBreakdown(index: number) {
  this.breakdownData.splice(index, 1);
  this.printingForm.patchValue({ breakdown: this.breakdownData });

  if (this.breakdownEditingIndex === index) {
    this.resetCurrentBreakdown();
    this.breakdownEditingIndex = -1;
  }
}

resetCurrentBreakdown() {
  this.currentBreakdown = {
    downTime: '',
    downTimeTime: '',
    downTimeRemarks: ''
  };
}

// total calculation
getTotalDownTime(): number {
  return this.breakdownData.reduce((total, entry) => {
    const time = parseFloat(entry.downTimeTime) || 0;
    return total + time;
  }, 0);
}


solventDialogVisible = false;

currentSolvent = {
  solType: '',
  solIssue: '',
  solReturn: '',

  solConsumption: '',
};

solventData: any[] = [];
solventEditingIndex = -1;

openSolventDialog() {
  this.solventDialogVisible = true;
  this.resetCurrentSolvent();
}

closeSolventDialog() {
  this.solventDialogVisible = false;
  this.resetCurrentSolvent();
  this.solventEditingIndex = -1;
}

saveSolvent() {
  if (!this.currentSolvent.solType && !this.currentSolvent.solIssue && !this.currentSolvent.solReturn) return;

  // for patching calculated consumption
  this.currentSolvent.solConsumption = this.calculateConsumption(this.currentSolvent).toString();
  // 

  if (this.solventEditingIndex === -1) {
    this.solventData.push({ ...this.currentSolvent });
  } else {
    this.solventData[this.solventEditingIndex] = { ...this.currentSolvent };
    this.solventEditingIndex = -1;
  }

  this.resetCurrentSolvent();
  this.printingForm.patchValue({ solvent: this.solventData });
}

editSolvent(index: number) {
  this.currentSolvent = { ...this.solventData[index] };
  this.solventEditingIndex = index;
}

deleteSolvent(index: number) {
  this.solventData.splice(index, 1);
  this.printingForm.patchValue({ solvent: this.solventData });

  if (this.solventEditingIndex === index) {
    this.resetCurrentSolvent();
    this.solventEditingIndex = -1;
  }
}

resetCurrentSolvent() {
  this.currentSolvent = {
    solType: '',
    solIssue: '',
    solReturn: '',

    solConsumption: '',
  };
}

// calculation
calculateConsumption(solvent: any): number {
  const issue = parseFloat(solvent.solIssue) || 0;
  const ret = parseFloat(solvent.solReturn) || 0;
  return issue - ret;
}

getTotalSolvent(field: 'solIssue' | 'solReturn'): number {
  return this.solventData.reduce((acc, curr) => acc + (parseFloat(curr[field]) || 0), 0);
}

getTotalConsumption(): number {
  return this.solventData.reduce((acc, curr) => {
    const issue = parseFloat(curr.solIssue) || 0;
    const ret = parseFloat(curr.solReturn) || 0;
    return acc + (issue - ret);
  }, 0);
}

  
  
  
  
  
  
  
  
  
  // loadLaminationData(id: string): void {
  //   console.log('Selected ID:', id);
  
  //   this.laminationService.getLaminationById(id).subscribe(
  //     (response: any) => {
  //       this.laminationData = response;
  //       console.log('Fetched lamination data:', this.laminationData);
  
  //       if (
  //         this.laminationData &&
  //         this.laminationData.laminationFormData &&
  //         this.laminationData.laminationFormData.length > 0
  //       ) {
  //         const formData = this.laminationData.laminationFormData[0];
  
  //         // Patch simple controls
  //         this.laminationForm.patchValue({
  //           prNo: formData.prNo || '',
  //           date: formData.date ? new Date(formData.date) : null,
  //           date2: formData.date2 ? new Date(formData.date2) : null,
  //           prMachine: formData.prMachine || '',
  //           shift: formData.shift || '',
  //           workOrder: formData.workOrder || '',
  //           customer: formData.customer || '',
  //           product: formData.product || '',
  //           printFilm: formData.printFilm || '',
  //           rollNo: formData.rollNo || '',
  //           orderQuantity: formData.orderQuantity || '',
  //           deliveryDate: formData.deliveryDate || '',
  //           productCode: formData.productCode || '',
  //           workOrderProductType: formData.workOrderProductType || ''
  //         });
  
  //         // --- Material Details ---
  //         const materialDetailsArray = this.laminationForm.get('materialDetails') as FormArray;
  //         materialDetailsArray.clear();
  
  //         if (formData.materialDetails && formData.materialDetails.length > 0) {
  //           formData.materialDetails.forEach((material: any) => {
  //             const materialGroup = this.fb.group({
  //               woNo: [material.woNo || ''],
  //               itemWidth: [material.itemWidth || ''],
  //               itemThickness: [material.itemThickness || ''],
  //               itemGross: [material.itemGross || ''],
  //               itemScrap: [material.itemScrap || ''],
  //               itemUsed: [material.itemUsed || ''],
  //               itemBalanced: [material.itemBalanced || ''],
  //               itemInk: [material.itemInk || ''],
  //               batchNo: [material.batchNo || ''],
  //               batchDate: [material.batchDate || ''],
  //               batchQuantity: [material.batchQuantity || ''],
  //               expiryDate: [material.expiryDate || ''],
  //               remark: [material.remark || ''],
  //               dialogGross: [material.dialogGross || ''],
  //               dialogCore: [material.dialogCore || ''],
  //               dialogNet: [material.dialogNet || ''],
  //               dialogMeter: [material.dialogMeter || ''],
  //               dialogColor: [material.dialogColor || ''],
  //               dialogText: [material.dialogText || ''],
  //               dialogInputRoll: [material.dialogInputRoll || ''],
  //               dialogUsed: [material.dialogUsed || ''],
  //               dialogScrap: [material.dialogScrap || ''],
  //               dialogInk: [material.dialogInk || ''],
  //               dialogInBlnWt: [material.dialogInBlnWt || ''],
  
  //               // Add nested batches
  //               batches: this.fb.array([])
  //             });
  
  //             // Load batches if available
  //             if (material.batches && Array.isArray(material.batches)) {
  //               const batchesArray = materialGroup.get('batches') as FormArray;
  //               material.batches.forEach((batch: any) => {
  //                 const batchRow = this.createBatchRow(batch);
  //                 batchesArray.push(batchRow);
  //               });
  //             }
  
  //             materialDetailsArray.push(materialGroup);
  //           });
  //         } else {
  //           console.warn('No materialDetails found in laminationFormData');
  //         }
  
  //       } else {
  //         console.error('No Lamination form data available.');
  //         this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Lamination form data not found.' });
  //       }
  //     },
  //     (error) => {
  //       console.error('Error fetching lamination data:', error);
  //       if (error.status === 404) {
  //         this.messageService.add({ severity: 'error', summary: 'Not Found', detail: 'Lamination data not found.' });
  //       } else {
  //         this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load Lamination data.' });
  //       }
  //     }
  //   );
  // }





tickets = []; // Array to hold all ticket numbers
  onTicketSelect(event: any): void {
  const selectedTicketNo = event.target.value;
  if (selectedTicketNo) {
    const selectedTicket = this.tickets.find(ticket => ticket.ticketno === selectedTicketNo);
    if (selectedTicket) {

         console.log('🟢 Full Selected Ticket Object:', selectedTicket);


      // const width = selectedTicket.coilWidth || 'Default Width';
      const jobName = selectedTicket.jobName || 'Default Job Name';

      // const material = selectedTicket.combinedMaterials && selectedTicket.combinedMaterials.length > 0 
      // ? selectedTicket.combinedMaterials[0].material // Extracting the material from the first item
      // : 'Default Material'; // Default if no materials found

       
      // Filter combinedMaterials to get process === "PRINTING"
      const printingMaterial = selectedTicket.combinedMaterials
        ? selectedTicket.combinedMaterials.filter(material => material.process === "PRINTING")
        : [];

      // If there are any materials with process "PRINTING", pick the first one, else use default
      const material = printingMaterial.length > 0 
        ? printingMaterial[0].material 
        : ''; // Default if no material is found with process "PRINTING"
        const thickness = printingMaterial.length > 0 
        ? printingMaterial[0].thickness 
        : ''; // Default thickness if no printing material is found
      const width = printingMaterial.length > 0 
        ? printingMaterial[0].width 
        : ''; // Default width if no printing material is found


        
        const orderKgs = selectedTicket.orderKgs != null
  ? parseFloat(selectedTicket.orderKgs).toFixed(2)
  : '0.00';


        
      this.printingForm.patchValue({
      //  ticketNo: selectedTicket.ticketno,
       jobName: jobName,
      
       // date: selectedTicket.date,
        batch: selectedTicketNo,

        refNo: selectedTicket.refNo || 'Default Ref No',
        poNumber: selectedTicket.poNo || 'Default PO Number',
        clientName: selectedTicket.clientName || 'Default Client Name',
        std: selectedTicket.std || 'Default STD',
        // orderKgs:selectedTicket.orderKgs,
        orderKgs:orderKgs,


        material: material, // Setting the material here
        thickness: thickness, // Setting the thickness here
        width: width, // Setting the material width here
     
      });

        // Optionally populate the combinedMaterials array if available in the ticket
        // if (selectedTicket.combinedMaterials) {
        //   this.setCombinedMaterials(selectedTicket.combinedMaterials);
        // }
     
    }
  }
}
  
  
  
  
  onSubmit(): void {
    // Show a confirmation dialog before submitting
    const isConfirmed = window.confirm("Are you done with entering all the details for  the processes?");
  
    if (isConfirmed) {
      // Proceed with the form submission if the user clicked 'Yes'
      if (this.printingForm) {

        // for total
        const totalWastage = this.getTotal('itemWastage');
        const totalKgs = this.getTotal('itemGross');
        const totalJoint = this.getTotal('itemWidth');
        const totalReturn = this.getTotal('itemThickness');
        // 
        const totalConsumption = this.getTotal('itemConsumption');
        const totalMtrs = this.getTotal('itemMtrs');

        const totalOutputKgs = this.getTotal('itemInk');
        const totalOutputMeters = this.getTotal('itemScrap');
      const totalOutputFlags = this.getTotal('itemUsed');
      const totalOutputWastage = this.getTotal('itemBalanced');

          // Calculate net consumption
      const netConsumption = totalKgs - totalReturn;

      const netTotalConsumption = totalOutputKgs - totalOutputWastage;



        // for total of output roll
        const totalWastageOutputRoll = this.getOutputTotal('itemWastage');
        const totalKgsOutputRoll = this.getOutputTotal('itemGross');
        const totalJointOutputRoll = this.getOutputTotal('itemWidth');
        const totalMtrsOutputRoll = this.getOutputTotal('itemMtrs');

             // Calculate net consumption
      const netConsumptionOutputRoll = totalKgsOutputRoll - totalWastageOutputRoll;
        // 

    
      
      
        this.printingForm.patchValue({
          totalWastage: totalWastage,
          totalKgs: totalKgs,
          totalJoint: totalJoint,
          totalReturn: totalReturn,
          // 
          totalConsumption: totalConsumption,
          totalMtrs: totalMtrs,
          

          netConsumption: netConsumption,
          
          totalOutputKgs: totalOutputKgs,
          totalOutputMeters: totalOutputMeters,
      totalOutputFlags: totalOutputFlags,
      totalOutputWastage: totalOutputWastage,

      netTotalConsumption: netTotalConsumption,


// for patching ink also during form submission
      inking: this.inkingData,
      // breakdown: this.breakdownData,
      solvent: this.solventData,



      // here now for popups
      // inking
      totalInkIssue: this.getInkTotal('issue'),
      totalInkReturn: this.getInkTotal('return'),
      totalInkLiquidCons: this.getTotalLiquidCons(),
      totalInkSolidCons: this.getTotalSolidCons(),
       // Solvent popup values
       totalSolventIssue: this.getTotalSolvent('solIssue'),
       totalSolventReturn: this.getTotalSolvent('solReturn'),
       totalSolventConsumption: this.getTotalConsumption(),
      //  breakdown popup
      totalBreakdownTime: this.getTotalDownTime(),




      // for output roll
      totalWastageOutputRoll: totalWastageOutputRoll,
      totalKgsOutputRoll: totalKgsOutputRoll,
      totalJointOutputRoll: totalJointOutputRoll,
      totalMtrsOutputRoll: totalMtrsOutputRoll,

      netConsumptionOutputRoll:netConsumptionOutputRoll,
      // 

         
        });
        // 
        const formData = {
          ...this.printingForm.value,
          // Aggregate the previously saved data
          // addProduction: this.savedProductionData,
          // inking: this.savedInkData,
          // breakdown: this.printingForm.value.breakdown ? [
          //   {
          //     downTime: this.printingForm.value.downTime,
          //     downTimeTime: this.printingForm.value.downTimeTime,
          //     downTimeRemarks: this.printingForm.value.downTimeRemarks
          //   }
          // ] : []
          // complete table entry
          // breakdown: this.savedDownTimeData
        };
  
        // Log the individual sections of the form data
        // console.log('addProduction:', formData.addProduction);
        // console.log('inking:', formData.inking);
        // console.log('breakdown:', formData.breakdown);
  
        // Log the entire form data
        console.log('Form Data to be submitted:', formData);
  
        // Send the aggregated data to the backend
        this.productionService.addProduction(formData).subscribe(
          response => {
            console.log('printing created successfully:', response);
            // Reset the form and clear the saved data after successful submission
            // this.savedProductionData = [];
            // this.savedInkData = [];
            // this.printingForm.reset();

            this.Router.navigateByUrl('/prodRecord');  // This will redirect to the Table
          },
          error => {
            console.error('Error creating printing:', error);
          }
        );
      } else {
        console.log('Form is invalid:', this.printingForm.errors);
      }
    } else {
      // If the user clicked 'No', cancel the form submission
      console.log('Form submission canceled.');
    }
  }
  
  
  
  
  
  
  
  
  clearAfterSave() {
    // After saving or updating, remove the most recent item from the rolls list
    if (this.rolls.length > 0) {
      const savedRoll = this.rolls[this.rolls.length - 1];  // We already saved the most recent roll
      console.log('Saving and removing roll:', savedRoll);
  
      // After saving, remove that roll from the table (and localStorage)
      this.rolls = this.rolls.slice(0, this.rolls.length - 1); // Remove the last roll from the list
      localStorage.setItem('rolls', JSON.stringify(this.rolls)); // Update localStorage with remaining rolls
      this.serialNo = this.rolls.length > 0 ? this.rolls[this.rolls.length - 1].no + 1 : 1; // Reset serial number for new rolls
      this.printingForm.reset(); // Reset the form after save
      
    }
  }
  
  
  
  
  // for editing of batch data
  editingBatchIndex: number | null = null;
  
  editBatchRow(batch: any, index: number): void {
    this.editingBatchIndex = index;
  
    this.selectedBatchRow = this.fb.group({
      woNo: [this.selectedMaterialRow?.get('woNo')?.value || ''],
      batchNo: [batch.batchNo || ''],
    
      remark: [batch.remark || ''],
      // dialogGross: [batch.dialogGross || ''],
      // dialogCore: [batch.dialogCore || ''],
      // dialogNet: [batch.dialogNet || ''],
      dialogMeter: [batch.dialogMeter || ''],
      dialogColor: [batch.dialogColor || ''],
      dialogText: [batch.dialogText || ''],
      dialogInputRoll: [batch.dialogInputRoll || ''],
      // dialogUsed: [batch.dialogUsed || ''],
      // dialogScrap: [batch.dialogScrap || ''],
      // dialogInk: [batch.dialogInk || ''],
      dialogInBlnWt: [batch.dialogInBlnWt || ''],
    
    });
  
    this.batchDialogVisible = true;
    this.attachBatchCalculations(this.selectedMaterialRow!, true); // Only during edit
  

    this.updateAllBatchLinkedTotals();
  }
  
  
  // working deletion as well
  deleteBatchRow(index: number): void {
    if (this.selectedMaterialRow) {
      const batchesArray = this.selectedMaterialRow.get('batches') as FormArray;
  
      if (batchesArray && batchesArray.length > index) {
        const confirmDelete = confirm('Are you sure you want to delete this batch?');
  
        if (confirmDelete) {
          // Capture deleted roll no
          const deletedBatch = batchesArray.at(index);
          const deletedRollNo = deletedBatch.get('batchNo')?.value || '';
  
          // Remove the batch
          batchesArray.removeAt(index);
  
          // Set deleted roll no back into batch dialog input for reuse
          this.selectedBatchRow?.get('batchNo')?.setValue(deletedRollNo);
  
          // Update 'lastUsedRollNo' in parent form & local variable
          this.selectedMaterialRow.get('lastUsedRollNo')?.setValue(deletedRollNo, { emitEvent: false });
          this.lastUsedRollNo = deletedRollNo;
  
          // Also update your internal roll number counter if needed
          // Extract numeric part from deleted roll no: assumes format like "247S00012"
          const numericPart = parseInt(deletedRollNo.slice(4), 10);
          const currentNumeric = parseInt(this.lastUsedRollNo.slice(4), 10);
  
          // Roll back currentRollNumber if deleted is smaller than current
          if (!isNaN(numericPart) && numericPart < this.currentRollNumber) {
            this.currentRollNumber = numericPart;
          }
  
          // Optionally store for future use
          this.lastDeletedRollNo = deletedRollNo;

          this.updateAllBatchLinkedTotals();
        }
      }
    }
  }
  
  lastDeletedRollNo: string | null = null;
  
  
  
  private attachBatchCalculations(row: FormGroup, runCalculations: boolean = false): void {
    if (!runCalculations) return; // 🔒 Do nothing unless explicitly told
  
    const grossCtrl = this.selectedBatchRow.get('dialogGross');
    const coreCtrl = this.selectedBatchRow.get('dialogCore');
    const netCtrl = this.selectedBatchRow.get('dialogNet');
  
    const inputCtrl = this.selectedBatchRow.get('dialogInputRoll');
    const usedCtrl = this.selectedBatchRow.get('dialogUsed');
    const scrapCtrl = this.selectedBatchRow.get('dialogScrap');
  
    const inBlnWtCtrl = this.selectedBatchRow.get('dialogInBlnWt');
    const inkCtrl = this.selectedBatchRow.get('dialogInk');
  
    const updateNet = () => {
      const gross = +grossCtrl?.value || 0;
      const core = +coreCtrl?.value || 0;
      netCtrl?.setValue(gross - core, { emitEvent: false });
    };
  
    const updateInBlnWt = () => {
      const input = +inputCtrl?.value || 0;
      const used = +usedCtrl?.value || 0;
      const scrap = +scrapCtrl?.value || 0;
      const inBln = input - used - scrap;
      inBlnWtCtrl?.setValue(inBln, { emitEvent: false });
  
      row.get('itemBalanced')?.setValue(inBln, { emitEvent: false });
    };
  
    const updateInk = () => {
      const used = +usedCtrl?.value || 0;
      const inputRoll = +inputCtrl?.value || 0;
      const ink = used > inputRoll ? used - inputRoll : 0;
      inkCtrl?.setValue(ink, { emitEvent: false });
  
      row.get('itemInk')?.setValue(ink, { emitEvent: false });
    };
  
    grossCtrl?.valueChanges.subscribe(updateNet);
    coreCtrl?.valueChanges.subscribe(updateNet);
  
    inputCtrl?.valueChanges.subscribe(() => {
      updateInBlnWt();
      updateInk();
    });
  
    usedCtrl?.valueChanges.subscribe(() => {
      updateInBlnWt();
      updateInk();
      row.get('itemUsed')?.setValue(usedCtrl.value, { emitEvent: false });
    });
  
    scrapCtrl?.valueChanges.subscribe(() => {
      updateInBlnWt();
      updateInk();
      row.get('itemScrap')?.setValue(scrapCtrl.value, { emitEvent: false });
    });
  
    updateNet();
    updateInBlnWt();
    updateInk();
  }
  
  
  
  
  //   onSubmit(): void {
  //     if (this.printingForm) {
  //         if (this.printingId) {
  //             // Update existing printing
  //             this.printingService.updatePrinting(this.printingId, this.printingForm.value).subscribe(
  //                 response => {
  //                     console.log('printing updated successfully:', response);
  //                     this.messageService.add({ severity: 'success', summary: 'Success', detail: 'printing updated successfully!' });
  //                     this.printingForm.reset();
  //                 },
  //                 error => {
  //                     console.error('Error updating printing:', error);
  //                     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error updating printing. Please try again.' });
  //                 }
  //             );
  //         } else {
  //             // Create new printing
  
  
  //             this.printingService.addPrinting(this.printingForm.value).subscribe(
  //                 response => {
  //                     console.log('printing created successfully:', response);
  //                     this.messageService.add({ severity: 'success', summary: 'Success', detail: 'printing created successfully!' });
  //                     this.printingForm.reset();
  //                 },
  //                 error => {
  //                     console.error('Error creating printing:', error);
  //                     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error creating printing. Please try again.' });
  //                 }
  //             );
  //         }
  //     } else {
  //         console.log('Form is invalid:', this.printingForm.errors);
  //         this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Form is invalid. Please check your inputs.' });
  //     }
  // }
  
  
  
  
  
  // Method to add new roll information to the table
  // addRoll() {
  //   if (this.printingForm.valid) {
  //     const newRoll = { ...this.printingForm.value };  // Clone form value
  //     newRoll.no = this.serialNo;                       // Add serial number
  //     newRoll.downtimeList = [...this.downtimeList];    // Include downtime data for this roll
  //     newRoll.scrappingList = [...this.scrappingList];  // Include scrapping data for this roll
  //     newRoll.manpowerList = [...this.manpowerList];    // Include manpower data for this roll
  //     newRoll.jobTimingList = [...this.JobTimingList];  // Include job timing data for this roll
  
  //     // Add roll to the table array
  //     this.rolls.push(newRoll);
  //     console.log(this.rolls);
  
  //     this.serialNo++;  // Increment serial number for the next entry
  //     this.printingForm.reset();  // Reset form for the next entry
  
  //     // Save updated rolls array to localStorage
  //     localStorage.setItem('rolls', JSON.stringify(this.rolls));
  
  //     console.log(this.rolls);
  //   } else {
  //     this.messageService.add({ severity: 'error', summary: 'Form Error', detail: 'Please fill in all required fields!' });
  //   }
  // }
  addRoll() {
    // Bypass the form validation check
    const newRoll = { ...this.printingForm.value };  // Clone form value
    newRoll.no = this.serialNo;                       // Add serial number
    // newRoll.downtimeList = [...this.downtimeList];    // Include downtime data for this roll
    // newRoll.scrappingList = [...this.scrappingList];  // Include scrapping data for this roll
    // newRoll.manpowerList = [...this.manpowerList];    // Include manpower data for this roll
    // newRoll.jobTimingList = [...this.JobTimingList];  // Include job timing data for this roll
  
    // newRoll.balanceRollList = [...this.balanceRollList];
    // newRoll.solventList = [...this.solventList];
    // newRoll.inkList = [...this.inkList];
    // newRoll.processParametersList = [...this.processParametersList];
    // newRoll.otherList = [...this.otherList];
  
      // ✅ Capture and log materialDetails
    newRoll.materialDetails = this.materialDetails.value;
    console.log('Material Details being added to roll:', newRoll.materialDetails);
  
    // newRoll.batches = this.batches.value;
    // console.log('Material Details being added to roll:', newRoll.batches);
  
   
    // Add roll to the table array
    this.rolls.push(newRoll);
    console.log(this.rolls);
  
    this.serialNo++;  // Increment serial number for the next entry
    this.printingForm.reset();  // Reset form for the next entry
  
    // Save updated rolls array to localStorage
    // localStorage.setItem('rolls', JSON.stringify(this.rolls));
  
    console.log(this.rolls);
  }
  
  
  // Method to handle Save & Print Label button
  save() {
    // Add the roll to the rolls array
    this.addRoll();
  }
  
  
  
  
  
  
  
  
  }